// A szerkezet-oldal MEGSZŰNT: a hét művelete (átnevezés, megjelenés, archiválás, láthatóság,
// törlés, új szekció, új könyv) átkerült a tudástár szerkesztés-módjába — egy hely, egy mentális
// modell. A régi oldal külön katalógus-másolat volt, ami nem mutatta a könyvek TARTALMÁT: nem
// lehetett látni, mi van a „Felhasználói kézikönyv › Általános"-ban, miközben épp azt szerkesztetted.
//
// Az útvonal azért marad, hogy a meglévő linkek és könyvjelzők ne haljanak el.
import { createFileRoute, redirect } from '@tanstack/react-router';

import { requireAuth } from '@/lib/auth';

export const Route = createFileRoute('/szerkezet')({
  beforeLoad: async ({ location }) => {
    await requireAuth(location.href);
    throw redirect({ to: '/tudastar', search: { szerkesztes: '1' }, replace: true });
  },
});
